"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const absoluteMinWidth = 200;
const Sidebar = _ref => {
  let {
    title,
    minWidth = 0,
    maxWidth = 999999,
    defaultWidth,
    children
  } = _ref;
  const [collapsed, setCollapsed] = (0, _react.useState)(localStorage.getItem('sidebarCollapsed') === 'true');
  const [activeDrag, setActiveDrag] = (0, _react.useState)(false);
  const [width, setWidth] = (0, _react.useState)(parseFloat(localStorage.getItem('sidebarWidth'), 10) || defaultWidth);
  const isDragged = (0, _react.useRef)(false);
  const targetRef = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(() => {
    if (targetRef.current && !collapsed) {
      setWidth(targetRef.current.offsetWidth);
    }
  }, []);
  const collapseSidebar = () => {
    setCollapsed(true);
    localStorage.setItem('sidebarCollapsed', 'true');
  };
  const expandSidebar = () => {
    setCollapsed(false);
    localStorage.setItem('sidebarCollapsed', 'false');
  };
  (0, _react.useEffect)(() => {
    window.addEventListener('mousemove', e => {
      if (!isDragged.current) {
        return;
      }

      // document.body.style.userSelect = 'none';

      setWidth(previousWidth => {
        const newWidth = previousWidth + e.movementX;
        const isWidthInRange = newWidth >= minWidth && newWidth <= maxWidth;
        return isWidthInRange ? newWidth : previousWidth;
      });
      if (width < absoluteMinWidth) {
        setWidth(absoluteMinWidth);
        collapseSidebar();
      }
    });
    window.addEventListener('mouseup', () => {
      document.body.style.userSelect = 'auto';
      isDragged.current = false;
      setActiveDrag(false);
    });
  }, []);
  (0, _react.useEffect)(() => {
    localStorage.setItem('sidebarWidth', width);
  }, [width]);
  const asideWidth = collapsed ? 0 : width;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar is-flex is-relative overflow-y-hidden select-none",
    style: {
      overflowY: 'hidden',
      userSelect: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("aside", {
    className: "sidebar-aside is-relative is-flex is-flex-direction-column",
    style: {
      width: asideWidth >= 0 && asideWidth
    },
    ref: targetRef
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    isHidden: collapsed,
    textColor: "white",
    backgroundColor: "navy"
  }, /*#__PURE__*/_react.default.createElement(_core.Columns, null, /*#__PURE__*/_react.default.createElement(_core.Column, null, title), /*#__PURE__*/_react.default.createElement(_core.Column, {
    isNarrow: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    onClick: () => {
      collapseSidebar();
    },
    onKeyUp: () => {
      collapseSidebar();
    },
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "sidebar-toggle",
    name: "menu_open",
    color: "white",
    size: null
  })), ' ')), children)), collapsed && /*#__PURE__*/_react.default.createElement(_core.Button, {
    cornersRounded: true,
    color: "white",
    mt: 3,
    ml: 3,
    size: "small",
    py: 4,
    onClick: () => {
      expandSidebar();
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "sidebar-toggle",
    name: "menu",
    color: "navy",
    size: null
  })), /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    draggable: true,
    tabIndex: 0,
    className: `sidebar-handlebar ${activeDrag && 'is-active'}`,
    onMouseDown: e => {
      e.preventDefault();
      isDragged.current = true;
      setActiveDrag(true);
    }
  }));
};
Sidebar.propTypes = {
  title: _propTypes.default.string,
  minWidth: _propTypes.default.number,
  maxWidth: _propTypes.default.number,
  defaultWidth: _propTypes.default.number,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
var _default = exports.default = (0, _core.withUiProps)(Sidebar);
//# sourceMappingURL=Sidebar.js.map